<div>
  <!--<div class="info-strip clearfix">
    <div class="info-strip-right">
      <div id="list-two" class="basket" (drop)="drop(planImages,book,page,currentImageIndex)" (dragover)="allowDrop($event)">
        <app-plan-download [docId]="docID" [doctype]="docType" [planImages]="planImages" [pagecount]="pageCount" [book]="book" [page]="page" [currentindex]="currentIndex"></app-plan-download>
      </div>
    </div>
  </div>-->

  <div class="info-strip clearfix">
    <div class="info-strip-right">
      <div id="list-two" class="basket" *ngIf="showimageviewer" (drop)="drop(record.docDetail.docType,docbeginbook,docbeginpage,currentIndex)" (dragover)="allowDrop($event)">
        <app-doc-basket [docId]="docID" [doctype]="docType" [planImages]="planImages" [pagecount]="pageCount" [docbeginbook]="book" [docbeginpage]="page" [currentindex]="currentIndex"></app-doc-basket>
      </div>

      <!--<div class="title-here">
       <p style="font-size: 16px;"><span (click)="getPrevPlan($event)" < </span>  Plan Book {{book}} / Page {{page}}</p>  
      </div>-->

      <div class="book-page-here">
        <i tabindex="0" class="fa fa-caret-left" (click)="getPrevPlan($event)" title="Go to Previous Plan"></i>
        <p>Plan Book {{book}} / Page {{page}}</p>
        <i tabindex="0" class="fa fa-caret-right" (click)="getNextPlan($event)" title="Go to Next Plan"></i>
      </div>


      <div class="book-page-go">
        <span class="plus" tabindex="0" (click)="toggleGo()">+</span>
        <form #form="ngForm" (ngSubmit)="searchPlan(sBook,sPage)">
          <div class="book-page-go-hidden" [ngStyle]="{'display': screenWidth > 1000 ? 'block' : (collapseGo) ? 'block' : 'none'}">
            <input placeholder="Plan Bk" [(ngModel)]="sBook" name="sBook" />
            <input placeholder="Plan Pg" [(ngModel)]="sPage" name="sPage" />
          </div>
          <button type="submit">Go</button>
        </form>
      </div>
    </div>
  </div>


  <div>
    <div class="image-paging">
      <i tabindex="0" class="fa fa-angle-double-left" (click)="isFirstPage || getFirstPg($event)" [ngStyle]="{'color':isFirstPage ? 'grey' : '#21495C' }"></i>
      <i class="fa fa-angle-left" (click)="isFirstPage || getPrevPg($event)" [ngStyle]="{'color':isFirstPage ? 'grey' : '#21495C' }"></i>
      <p><span>p.</span>{{currentIndex}} of {{pageCount}}</p>
      <i class="fa fa-angle-right" (click)="isLastPage || getNextPg($event)" [ngStyle]="{'color':isLastPage ? 'grey' : '#21495C' }"></i>
      <i class="fa fa-angle-double-right" (click)="isLastPage || getLastPg($event)" [ngStyle]="{'color':isLastPage ? 'grey' : '#21495C' }"></i>
    </div>
    <div *ngIf="isLoadingImage; else showimage">
      <div class="imgpanel">
        Loading Image ...
      </div>
    </div>
    <ng-template #showimage>
      <div class="imgpanel" draggable="true" *ngIf="currentImage.length!=0 ; else showMsg"
           (dragstart)="drag($event)">
        <ngx-extended-pdf-viewer [base64Src]="blobImage"
                                 [height]="'auto'" [textLayer]="false"
                                 [zoom]="'auto'"
                                 [showToolbar]="true"
                                 [showSidebarButton]="false"
                                 [showFindButton]="false"
                                 [showPagingButtons]="false"
                                 [showDrawEditor]="false"
                                 [showStampEditor]="false"
                                 [showTextEditor]="false"
                                 [showZoomButtons]="always-visible"
                                 [showSelectScale]="always-visible"
                                 [showPresentationModeButton]="always-visible"
                                 [showOpenFileButton]="false"
                                 [showPrintButton]="false"
                                 [showDownloadButton]="false"
                                 [showSecondaryToolbarButton]="false"
                                 [showRotateButton]="true"
                                 [showRotateCwButton]="always-visible"
                                 [showRotateCcwButton]="always-visible"
                                 [showHighlightEditor]="false"
                                 [showHandToolButton]="false"
                                 [showScrollingButton]="true"
                                 [showSpreadButton]="false"
                                 [enablePinchOnMobile]="true"
                                 [useBrowserLocale]="true"
                                 [showPropertiesButton]="false">
        </ngx-extended-pdf-viewer>
        <app-image-viewer [images]="currentImage"
                          [idContainer]="'idOnHTML'"
                          [loadOnInit]="true"
                          [showPDFOnlyOption]="false"
                          (onNext)="getNextPg($event)"
                          [fullscreen]="false"
                          [download]="false"
                          (onPrevious)="getPrevPg($event)"></app-image-viewer>
      </div>
      <ng-template #showMsg>
        <!--<h2>Image Not Found</h2>-->
        <h2>Loading....</h2>
      </ng-template>
    </ng-template>
  </div>

  <dx-popup [width]="350"
            [height]="150"
            [showTitle]="true"
            title="Information"
            [dragEnabled]="false"
            [closeOnOutsideClick]="true"
            [(visible)]="popupVisible">
    <div>
      <p>
        {{Message}}
      </p>
    </div>
  </dx-popup>
</div>
